import React from "react";
import styles from "./OfflineErrorBox.module.scss";

const OfflineErrorBox = ({ isOnline = true }) => {

    return (
        !isOnline &&
            <div className={styles.OfflineErrorBoxContainer}>
                <div className={`d-flex justify-content-between ${styles.offlineErrorBox}`}>
                    <div>
                        <div className={styles.title}>
                            It seems you are&nbsp;<span> offline </span>!
                        </div>
                        <p>
                            We can't process requests in offline mode. Please check your internet connection. This message will be closed when you are online again!
                        </p>
                    </div>
                </div>
            </div>
    )
}

export default OfflineErrorBox;